export default __webpack_public_path__ + "static/media/register.765dd882.svg";